import { Button } from 'components/universal/button';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IProduct } from 'types/cart';
import { replaceToPositiveNumbers } from 'utils/regexp';
import styles from './product.module.scss';

interface IProps {
    product: IProduct;
}

export const Product: FC<IProps> = ({ product }) => {
    const { t } = useTranslation('', {
        keyPrefix: 'download',
    });


    const thumbnail_url = product?.thumbnail_url;

    return (
        <div className={styles.product}>
            <img
                className={styles.productImage}
                src={thumbnail_url}
            />
            <div className={styles.productInfo}>
                <div className={styles.productInfoTop}>
                    <p className={styles.productType}>
                        {product?.category_name}
                    </p>
                    <p className={styles.productName}>{product?.title}</p>
                </div>
                <div className={styles.inputWrapper}>
                    <Button
                        className={styles.productButton}
                    >
                        {t('downloadButtonLabel')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
